import $ from 'jquery';
import i18next from 'i18next';
import XHR from 'i18next-xhr-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import jqueryI18next from 'jquery-i18next';

i18next.use(LanguageDetector);
i18next.use(XHR);
i18next.init({
    debug: false,
    supportedLngs: ['it', 'rm', 'de', 'fr'],
    fallbackLng: "fr",
    backend: {
        loadPath: '{{ns}}s_{{lng}}.json'
    }
}, function() {
    jqueryI18next.init(i18next, $);
    $(document).localize();
});